import React, { useRef } from 'react';
import { Field, Form as FinalForm } from 'react-final-form';
import { Button, FieldDateRangeInput, Form, LocationAutocompleteInput } from '../../../../../components';
import { getDefaultTimeZoneOnBrowser, getStartOf, timeOfDayFromTimeZoneToLocal } from '../../../../../util/dates';
import { FormattedMessage, useIntl } from '../../../../../util/reactIntl';

import css from "./SearchForm.module.css";
import { createResourceLocatorString } from '../../../../../util/routes';
import { useHistory } from 'react-router-dom';
import { useRouteConfiguration } from '../../../../../context/routeConfigurationContext';
import moment from 'moment';
import { isInclusivelyAfterDay } from 'react-dates';

const identity = v => v;

const LocationSearchField = props => {
    const { intl, inputRef, onLocationChange } = props;
    return (
        <Field
            name="location"
            format={identity}
            render={({ input, meta }) => {
                const { onChange, ...restInput } = input;

                const searchOnChange = value => {
                    onChange(value);
                    onLocationChange(value);
                };

                return (
                    <LocationAutocompleteInput
                        className={css.desktopInputRoot}
                        iconClassName={css.desktopIcon}
                        inputClassName={css.desktopInput}
                        predictionsClassName={css.desktopPredictions}
                        placeholder={intl.formatMessage({ id: 'SearchForm.placeholder' })}
                        inputRef={inputRef}
                        input={{ ...restInput, onChange: searchOnChange }}
                        meta={meta}
                    />
                );
            }}
        />
    );
};

const SearchForm = props => {
    const searchInputRef = useRef(null);
    const intl = useIntl();
    const history = useHistory();
    const routeConfiguration = useRouteConfiguration();

    const setSearchInputRef = (element) => {
        searchInputRef.current = element; // Assign the DOM element to the ref
    };

    const onSubmit = (values) => {
        if (values.location?.selectedPlace && values.bookingDates) {
            const { bounds } = values.location?.selectedPlace;
            const { startDate, endDate } = values.bookingDates;
            const startDateString = startDate?.toISOString().split('T')[0];
            const endDateString = endDate?.toISOString().split('T')[0];

            const searchParams = {
                bounds,
                dates: `${startDateString},${endDateString}`,
            };

            history.push(createResourceLocatorString('SearchPage', routeConfiguration, {}, searchParams));

        } else if (values.location?.selectedPlace && !values.bookingDates) {
            const { bounds } = values?.location?.selectedPlace;

            history.push(createResourceLocatorString('SearchPage', routeConfiguration, {}, { bounds }));

        } else if (!values.location?.selectedPlace && values.bookingDates) {
            const { startDate, endDate } = values.bookingDates;
            const startDateString = startDate?.toISOString().split('T')[0];
            const endDateString = endDate?.toISOString().split('T')[0];

            const searchParams = {
                dates: `${startDateString},${endDateString}`,
            };

            history.push(createResourceLocatorString('SearchPage', routeConfiguration, {}, searchParams));

        } else {
            history.push(createResourceLocatorString('SearchPage', routeConfiguration, {}, {}));
        }
    };


    const onChange = (location) => {
        if (location.selectedPlace) {
            searchInputRef?.current.blur();
        }
    };

    const formatDate = date => new Intl.DateTimeFormat('en-US').format(date);
    const startDatePlaceholderText = formatDate(new Date());
    const endDatePlaceholderText = formatDate(getStartOf(new Date(), 'day', 'Etc/UTC', 1, 'days'));
    const defaultTimeZone = () => typeof window !== 'undefined' ? getDefaultTimeZoneOnBrowser() : 'Etc/UTC';

    return (
        <FinalForm
            {...props}
            onSubmit={onSubmit}
            render={formRenderProps => {
                const {
                    values,
                    handleSubmit,
                } = formRenderProps;

                console.log(values)

                return (
                    <Form
                        className={css.root}
                        onSubmit={handleSubmit}
                    >
                        <LocationSearchField
                            intl={intl}
                            inputRef={setSearchInputRef}
                            onLocationChange={onChange}
                        />

                        <FieldDateRangeInput
                            name="bookingDates"
                            dateRangeInputClassName={css.dateRangeInput}
                            isDaily={false}
                            startDateId="bookingStartDate"
                            startDatePlaceholderText={intl.formatMessage({ id: 'SearchForm.startDate' })}
                            endDateId="bookingEndDate"
                            endDatePlaceholderText={intl.formatMessage({ id: 'SearchForm.endDate' })}
                            format={v => {
                                const { startDate, endDate } = v || {};
                                const formattedStart = startDate
                                    ? timeOfDayFromTimeZoneToLocal(startDate, defaultTimeZone())
                                    : startDate;
                                const formattedEnd = endDate
                                    ? timeOfDayFromTimeZoneToLocal(endDate, defaultTimeZone())
                                    : endDate;
                                return v ? { startDate: formattedStart, endDate: formattedEnd } : v;
                            }}
                            isBlockedBetween={() => () => false}
                            isDayBlocked={() => () => false}
                            isOutsideRange={day => day => !isInclusivelyAfterDay(day, moment())}
                        />
                        <Button
                            type="submit"
                            className={css.ctaButton}
                        >
                            <FormattedMessage id="SearchForm.search" />
                        </Button>
                    </Form>
                );
            }}
        />
    );
};

export default SearchForm;